import { cn } from '@/utils/cn';

type PageLoaderInnerProps = {
  show?: boolean;
  progress?: number;
};

// <https://webdeasy.de/en/css-loader/>
const PageLoaderInner = ({ show = false, progress }: PageLoaderInnerProps) => {
  const containerCn = cn(
    // Fullscreen
    ['w-full', 'h-screen'],
    ['fixed', 'inset-0'],
    'z-max',
    // Background
    ['bg-white/50', 'backdrop-blur-sm'],
    // Flex container
    ['flex', 'flex-col', 'items-center', 'justify-center', 'gap-12'],
    // Animation
    'animate-in fade-in duration-500',
    show ? 'opacity-1' : 'invisible opacity-0',
  );
  const textCn = cn('inline-block', 'mx-1.5', 'animate-pageloader-blur-text');
  const circleCn = cn(
    ['w-5', 'h-5'],
    'bg-primary-800',
    ['absolute', 'rounded-full', 'origin-center'],
    'animate-pageloader-bounce-circle',
  );
  const shadowCn = cn(
    ['w-5', 'h-1'],
    'top-16',
    'bg-black/50',
    ['absolute', 'rounded-full', 'origin-center'],
    'z-[-1]',
    'blur-[1px]',
    'animate-pageloader-circle-shadow',
  );
  const leftCn = cn('left-0');
  const centerCn = cn('left-0', 'right-0', 'mx-auto');
  const rightCn = cn('right-0');

  const progressChoice = [
    'w-1/12',
    'w-2/12',
    'w-3/12',
    'w-4/12',
    'w-5/12',
    'w-6/12',
    'w-7/12',
    'w-8/12',
    'w-9/12',
    'w-10/12',
    'w-11/12',
    'w-full',
  ];

  return (
    <div className={cn(containerCn)}>
      <div className="w-full text-center font-quattrocento text-sm text-black">
        <span className={cn(textCn)}>L</span>
        <span className={cn(textCn, 'animation-delay-200')}>O</span>
        <span className={cn(textCn, 'animation-delay-400')}>A</span>
        <span className={cn(textCn, 'animation-delay-600')}>D</span>
        <span className={cn(textCn, 'animation-delay-800')}>I</span>
        <span className={cn(textCn, 'animation-delay-1000')}>N</span>
        <span className={cn(textCn, 'animation-delay-1200')}>G</span>
      </div>

      <div className="relative h-32 w-36">
        <div className={cn(circleCn, leftCn)}></div>
        <div className={cn(circleCn, centerCn, 'animation-delay-200')}></div>
        <div className={cn(circleCn, rightCn, 'animation-delay-300')}></div>

        <div className={cn(shadowCn, leftCn)} />
        <div className={cn(shadowCn, centerCn, 'animation-delay-200')} />
        <div className={cn(shadowCn, rightCn, 'animation-delay-300')} />
      </div>

      {progress !== undefined && (
        <div className="flex w-full justify-center">
          <div className="h-2 w-1/2 rounded-full bg-primary-200 text-center">
            <div
              className={cn(
                progressChoice[Math.floor(progress * 12)],
                'h-2',
                'bg-primary-800',
                'rounded-full',
                'transition-all',
                'duration-200',
              )}
            ></div>
            <span className="font-quattrocento">
              {(progress * 100).toFixed()}%
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

PageLoaderInner.displayName = 'PageLoaderInner';
export { PageLoaderInner };
